import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';

/**
* @ngdoc service
* @name notifications.UserNotifications
*
* @description
* This class is used to process notifications on user.
*/
const UserNotifications = {

    /**
   * @ngdoc function
   * @name notifications.UserNotifications#processUpdate
   * @methodOf notifications.UserNotifications
   * @function
   *
   * @description
   * This function can be used to process updates made on a user.
   *
   * @param {object} data an object with updated values on user.
   */
    processUpdate(data) {

        if (data['attributes.optin'] === 'double_confirmed') {

            if (CWCONFIG.features.accountConfirmation) {

                Alert.success('cw.notification.account_verification.verified', null, 60000);

            }

        }

        // TODO: check for change of photo:  Mixpanel.send('Change Photo Success');

    },

};

export default UserNotifications;



// WEBPACK FOOTER //
// ./scripts/common/notifications/-RFC.userNotifications.js